import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface SolutionSummary {
  id: string;
  name?: string;
  key?: string;
  displayOrder: number;
}

export interface ClaimContextSolutionStepInfo {
  selectedWarrantyId?: string;
  selectedWarrantyName?: string;
  solutions?: SolutionSummary[];
}

export interface GetClaimSolutionsQueryArgs {
  claimId: string;
}

export const getClaimSolutionsRequest = ({
  claimId,
}: GetClaimSolutionsQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}/solutions`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimSolutionsQuery = async (
  args: GetClaimSolutionsQueryArgs,
): Promise<
  BackResponse<ClaimContextSolutionStepInfo> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<ClaimContextSolutionStepInfo>>(
      getClaimSolutionsRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
